import Vue from "vue";
import Router from "vue-router";
import Accueil from "@/components/Accueil";
import AccueilToolbar from "@/components/AccueilToolbar";
import SenateurCentral from "@/components/SenateurCentral";
import SenateurGauche from "@/components/SenateurGauche";
import SenateurDroite from "@/components/SenateurDroite";
import SenateurToolbar from "@/components/SenateurToolbar";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "calendrier_activite",
  routes: [
    {
      path: "/",
      name: "Accueil",
      components: { default: Accueil, toolbar: AccueilToolbar },
      props: {default: (route) => ({
        matricule: route.query.matricule
      })}
    },
    {
      path: "/senateur/:matricule",
      name: "senateur",
      components: {default: SenateurCentral, gauche: SenateurGauche, droite: SenateurDroite, toolbar: SenateurToolbar},
      props: {default: true, gauche: true, droite: true, toolbar: true}
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js